import React, { useState, useEffect } from 'react';
import {
  CssBaseline,
  Typography,
  Button,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Paper,
  Collapse,
  Link,
  Fab,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  Switch,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AddCollege from '../dashboard/add-new-college';
import { useDispatch, useSelector } from 'react-redux';
import { fetchColleges, updateCollege } from '../../redux/actions/collegesActions';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import './styles.css';
import { useMediaQuery, useTheme } from '@mui/material';

function CollegesTabContent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const colleges = useSelector((state) => state.colleges.data);
  const loading = useSelector((state) => state.colleges.loading);
  const error = useSelector((state) => state.colleges.error);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [collegeToEdit, setCollegeToEdit] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleEditCollege = (college) => {
    setCollegeToEdit(college);
    setIsAddDialogOpen(true);
  };

  const handleExpandRow = (rowId) => {
    if (rowId === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowId);
    }
  };

  useEffect(() => {
    dispatch(fetchColleges());
  }, [dispatch]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleAddCollege = () => {
    setCollegeToEdit(null);
    setIsAddDialogOpen(true);
  };

  const handleCloseAddDialog = () => {
    setIsAddDialogOpen(false);
    setCollegeToEdit(null);
  };

  const handleSaveCollege = (newCollegeData) => {
    setIsAddDialogOpen(false);
    setCollegeToEdit(null);
  };
  const handleActivateCollege = (college) => {
    var updatedCollege = {
      ...college,
      isActive: true
    };
    dispatch(updateCollege(updatedCollege));
  };

  const handleDeactivateCollege = (college) => {
    var updatedCollege = {
      ...college,
      isActive: false
    };
    dispatch(updateCollege(updatedCollege));
  };

  return (
    <div>
      <CssBaseline />
      <Fab
        aria-label="add"
        style={{
          position: 'fixed',
          backgroundColor: '#FC6258',
          bottom: '16px',
          right: '16px',
        }}
        onClick={handleAddCollege}
      >
        <AddIcon style={{ color: 'white' }} />
      </Fab>
      <div>
        {isMobile ? (
          colleges.map((college) => (
            <Card key={college.id} style={{ margin: '16px' }}>
            <CardHeader
              title={college.name}
              subheader={college.address}
              action={
                <IconButton
                  aria-label={expandedRow === college.id ? 'Collapse' : 'Expand'}
                  onClick={() => handleExpandRow(college.id)}
                >
                  {expandedRow === college.id ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </IconButton>
              }
            />
            <Collapse in={expandedRow === college.id} timeout="auto" unmountOnExit>
              <CardContent>
                <Typography variant="body2" paragraph>
                  {college.description}
                </Typography>
                <Link href={college.webSite} target="_blank" rel="noopener noreferrer">
                  {college.webSite}
                </Link>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  style={{ backgroundColor: '#FC6258' }}
                  onClick={() => navigate(`/universities/${college.id}`)}
                >
                  Liste des élèves
                </Button>
                <IconButton aria-label="Edit" onClick={() => handleEditCollege(college)}>
                  <EditIcon />
                </IconButton>
                <Switch
                  checked={college.isActive}
                  onChange={() => {
                    if (college.isActive) {
                      handleDeactivateCollege(college.id);
                    } else {
                      handleActivateCollege(college.id);
                    }
                  }}
                />
              </CardActions>
            </Collapse>
          </Card>
          ))
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Icône</TableCell>
                  <TableCell>Nom</TableCell>
                  <TableCell>Localisation</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Site web</TableCell>
                  <TableCell>Modifier</TableCell>
                  <TableCell>Activation</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {colleges.map((college) => (
                  <React.Fragment key={college.id}>
                    <TableRow>
                      <TableCell>
                        <img
                          src={college.path}
                          alt={college.name}
                          style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '40px',
                            overflow: 'hidden',
                            objectFit: 'cover',
                          }}
                        />
                      </TableCell>
                      <TableCell>{college.name}</TableCell>
                      <TableCell>{college.address}</TableCell>
                      <TableCell>
                        <IconButton
                          aria-label={
                            expandedRow === college.id ? 'Collapse' : 'Expand'
                          }
                          onClick={() => handleExpandRow(college.id)}
                        >
                          {expandedRow === college.id ? (
                            <ExpandLessIcon />
                          ) : (
                            <ExpandMoreIcon />
                          )}
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        <a
                          href={college.webSite}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {college.webSite}
                        </a>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          aria-label="Edit"
                          onClick={() => handleEditCollege(college)}
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        <Switch
                          checked={college.isActive}
                          onChange={() => {
                            if (college.isActive) {
                              handleDeactivateCollege(college);
                            } else {
                              handleActivateCollege(college);
                            }
                          }}
                        />
                    </TableCell>
                      <TableCell>
                        <Link to={`/universities/${college.id}`}>
                          <Button
                            variant="contained"
                            style={{ backgroundColor: '#FC6258' }}
                            onClick={() => navigate(`/universities/${college.id}`)}
                          >
                            Liste des élèves
                          </Button>
                        </Link>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={9}>
                        <Collapse
                          in={expandedRow === college.id}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Typography variant="body2" paragraph>
                            {college.description}
                          </Typography>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
      <AddCollege
        isOpen={isAddDialogOpen}
        onClose={handleCloseAddDialog}
        onSave={handleSaveCollege}
        collegeToEdit={collegeToEdit}
      />
      {loading && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
    </div>
  );
}

export default CollegesTabContent;
